export default __webpack_public_path__ + "static/media/error.0961c802.svg";